import { MemberPhoneFixTool } from './phone/member-phone-fix-tool';

export const MemberAuthTool = (): JSX.Element => (
  <div>
    <MemberPhoneFixTool />
  </div>
);
